const t = ["oneOf", "anyOf", "allOf", "not"];
function i(o) {
  return t.some((n) => o[n] !== void 0);
}
export {
  t as compositions,
  i as hasComposition
};
